import { action, computed, observable, makeObservable } from 'mobx';

import { InputPanel } from './InputPanel/InputPanel';

export class InputPanelsStore {
  @observable inputPanels = new Map();

  constructor(root) {
    makeObservable(this);
    this.root = root;
  }

  @action
  reset() {
    this.inputPanels.clear();
  }

  getById(groupId) {
    if (groupId && !this.inputPanels.has(groupId)) {
      this.inputPanels.set(groupId, new InputPanel(this.root, groupId));
    }

    return this.inputPanels.get(groupId);
  }

  @action
  deleteById(groupId) {
    if (!this.inputPanels.has(groupId)) {
      return;
    }

    this.inputPanels.delete(groupId);
  }

  @computed
  get activeInputPanel() {
    if (!this.root.GroupsStore.activeGroupId) {
      return null;
    }

    return this.getById(this.root.GroupsStore.activeGroupId);
  }
}

export default InputPanelsStore;
